export default {
    PRIMARY : "#C6A755",
    ALT: "#5882BB",
    TEXT : "black",
}